import React from "react";
import NosotrosComponent from "../components/home/NosotrosComponent";

const Nosotros = () => {
  return <NosotrosComponent />;
};

export default Nosotros;
